import { ApiProperty } from '@nestjs/swagger';
import { SupplierRegionInterface } from '../interfaces/supplier-region.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';

export class SupplierRegionDto
  extends CommonEntityDto
  implements SupplierRegionInterface
{
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  supplierId!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  regionId!: string;
}
